import { useState } from 'react';

import { Button, ButtonProps } from '@mui/material';

interface ButtonWithDoubleClickPreventionProps
  extends Omit<ButtonProps, 'disabled'> {
  onClick?: () => Promise<void> | void;
  isDisabled?: boolean;
}

function ButtonWithDoubleClickPrevention({
  onClick,
  type,
  color,
  variant,
  size,
  children,
  isDisabled = false,
  ...rest
}: ButtonWithDoubleClickPreventionProps) {
  const [isClickDisabled, setIsClickDisabled] = useState<boolean>(false);
  const isButtonDisabled = isDisabled || isClickDisabled;

  const handleClick = async (
    event: React.MouseEvent<HTMLButtonElement>,
  ): Promise<void> => {
    if (isButtonDisabled) {
      event.preventDefault();
      return;
    }

    if (onClick) {
      setIsClickDisabled(true);

      try {
        await onClick();
      } finally {
        setTimeout(() => {
          setIsClickDisabled(false);
        }, 1000);
      }
    }
  };

  return (
    <Button
      onClick={handleClick}
      type={type}
      color={color}
      variant={variant}
      size={size}
      disabled={isButtonDisabled}
      {...rest}
    >
      {children}
    </Button>
  );
}

export { ButtonWithDoubleClickPrevention };
